import { FC } from 'react';

import { useAuth } from '@shared/state/hooks/useAuth';

//* 응답 시간 안내는 우리가 업무로 응대하는 계정에게만 보인다 —
//* 상조 직원(worker) 이상, 관리자, 판매자 계열. 게스트 구매자·비로그인 문의는
//* 응대 주체와 속도가 달라 약속하지 않는다.
export const EnquiryResponseTimeNotice: FC = () => {
  const {
    isAdmin,
    isBugoAgencyAdmin,
    isBugoAgencyBranchAdmin,
    isBugoAgencyWorker,
    isStoreSeller,
    isGiftAgent,
    isGiftBrandSeller,
  } = useAuth();

  const isStaff =
    isAdmin() ||
    isBugoAgencyAdmin() ||
    isBugoAgencyBranchAdmin() ||
    isBugoAgencyWorker() ||
    isStoreSeller() ||
    isGiftAgent() ||
    isGiftBrandSeller();

  if (!isStaff) return null;

  return (
    <div className="flex items-center gap-2 text-sm text-gray-500">
      <span
        className="h-1.5 w-1.5 shrink-0 rounded-full bg-green-500"
        aria-hidden="true"
      />
      <p>보통 10분 이내에 답변드려요</p>
    </div>
  );
};
